import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const { guest, guard } = require("./lib/auth");

export default new Router({
  // mode: 'hash',
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      name: "Login",
      path: "/login",
      component: () => import("@/views/dashboard/pages/Login/Index"),
      redirect: { name: "MainLogin" },
      children: [
        {
          name: "MainLogin",
          path: "/",
          component: () => import("@/views/dashboard/pages/Login/MainLogin"),
        },
        {
          name: "ResetPassword",
          path: "/reset-password",
          component: () => import("@/views/dashboard/pages/Login/ForgetPassword"),
          redirect: { name: 'stepOne'},
          children: [
            {
              name: "stepOne",
              path: "/",
              component: () => import("@/views/dashboard/pages/Login/ForgetPassword/StepOne"),
            }
          ]
        },
      ]
      // beforeEnter: guest,
    },
    {
      name: "PasswordReset",
      path: "/reset",
      component: () => import("@/views/dashboard/pages/Login/PasswordReset")
      // beforeEnter: guest,
    },
    {
      name: "pdfTransaction",
      path: "/pdf-transaction",
      component: () => import("@/views/dashboard/pages/Transaction/pdf-transaction.vue")
      // beforeEnter: guest,
    },
    {
      name: "Payment Link",
      path: "/pay/:id",
      component: () => import("@/views/paymentLink/Index")
      // beforeEnter: guest,
    },
    {
      name: "Nepal Pay",
      path: "/nepalpay/:id",
      component: () => import("@/views/paymentLink/NepalPay")
    },
    {
      name: "Payment Response",
      path: "/payment/:id",
      component: () => import("@/views/paymentLink/PaymentResponse")
      // beforeEnter: guest,
    },
    {
      name: "Payment Detail",
      path: "/linkpay/detail",
      component: () => import("@/views/paymentLink/PaymentDetail")
      // beforeEnter: guest,
    },
    {
      name: "Payment Success",
      path: "/linkpay/success/:id",
      component: () => import("@/views/paymentLink/Success")
    },
    {
      name: "Payment Fail",
      path: "/linkpay/failer/:id",
      component: () => import("@/views/paymentLink/PaymentFail")
    },
    {
      name: "Payment Cancel",
      path: "/linkpay/cancel",
      component: () => import("@/views/paymentLink/Cancel")
      // beforeEnter: guest,
    },
    {
      path: "/",
      component: () => import("@/views/dashboard/Index"),
      redirect: { name: "Login" },
      children: [
        // Dashboard
        {
          name: "Dashboard",
          path: "/dashboard",
          component: () => import("@/views/dashboard/pages/MainDashboard"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "SUPER_ADMIN",
              "ADMIN_USER",
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          }
        },
        {
          name: "Request Pay Index",
          path: "/request-pay",
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: ["MERCHANT_ADMIN"]
          },
          component: () =>
            import("@/views/dashboard/pages/RequestPay/Index.vue"),
          redirect: { name: "Request Pay" },
          children: [
            {
              name: "Request Pay",
              path: "/",
              beforeEnter: guard,
              component: () =>
                import("@/views/dashboard/pages/RequestPay/RequestPay.vue"),
              meta: {
                requiresAuth: true,
                authorize: ["MERCHANT_ADMIN"]
              }
            },
            {
              name: "Generate Link",
              path: "generate-link/:id/:amount/:currencyCode",
              beforeEnter: guard,
              component: () =>
                import("@/views/dashboard/pages/RequestPay/GenerateLink.vue"),
              meta: {
                requiresAuth: true,
                authorize: ["MERCHANT_ADMIN"]
              }
            }
          ]
          // beforeEnter: guard,
          // meta: {
          //     requiresAuth: true,
          // },
        },
        {
          name: "Transaction",
          path: "/transaction",
          component: () =>
            import("@/views/dashboard/pages/Transaction/Index.vue"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "SUPER_ADMIN",
              "ADMIN_USER",
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          }
        },

        {
          name: "Config",
          path: "/config",
          component: () => import("@/views/dashboard/pages/Config/index.vue"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "SUPER_ADMIN",
              "ADMIN_USER",
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          }
        },
        {
          name: "Profile",
          path: "/profile",
          component: () => import("@/views/dashboard/pages/Merchant/merchant-profile.vue"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          },
          children: [
            {
              name: "MerchantDetail",
              path: "/",
              beforeEnter: guard,
              component: () =>
                import("@/views/dashboard/pages/Merchant/MerchantDetail.vue"),
              meta: {
                requiresAuth: true,
                authorize: [
                  "MERCHANT_ADMIN",
                  "MERCHANT_USER"
                ]
              }
            }
          ]
        },
        {
          name: "Merchant",
          path: "/merchant",
          component: () => import("@/views/dashboard/pages/Merchant/Index.vue"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "SUPER_ADMIN",
              "ADMIN_USER",
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          },
          children: [
            {
              name: "Merchant List",
              path: "/",
              component: () =>
                import(
                  "@/views/dashboard/pages/Merchant/components/MerchantTable.vue"
                ),
              meta: {
                requiresAuth: true,
                authorize: [
                  "SUPER_ADMIN",
                  "ADMIN_USER",
                  "MERCHANT_ADMIN",
                  "MERCHANT_USER"
                ]
              }
            },
            {
              name: "MerchantDetail",
              path: "detail/:id",
              component: () =>
                import("@/views/dashboard/pages/Merchant/MerchantDetail.vue"),
              meta: {
                requiresAuth: true,
                authorize: [
                  "SUPER_ADMIN",
                  "ADMIN_USER",
                  "MERCHANT_ADMIN",
                  "MERCHANT_USER"
                ]
              }
            }
          ]
        },
        {
          name: "Users Table",
          path: "/users-table",
          component: () => import("@/views/dashboard/pages/Users/Index.vue"),
          beforeEnter: guard,
          meta: {
            requiresAuth: true,
            authorize: [
              "SUPER_ADMIN",
              "ADMIN_USER",
              "MERCHANT_ADMIN",
              "MERCHANT_USER"
            ]
          },
          children: [
            {
              name: "User List",
              path: "/",
              beforeEnter: guard,
              meta: {
                requiresAuth: true,
                authorize: [
                  "SUPER_ADMIN",
                  "ADMIN_USER",
                  "MERCHANT_ADMIN",
                  "MERCHANT_USER"
                ]
              },
              component: () =>
                import("@/views/dashboard/pages/Users/user-list.vue")
            }
          ]
        }
        // Pages
      ]
    },
    {
      name: "page-not-found",
      path: "*",
      component: () => import("@/views/error/404")
    }
  ]
});
